// src/components/JarvislyModule/PageHeader/CardHeaderSubtitle.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';
import SimpleTag from 'components/SimpleComponents/SimpleTag';
import entitiesService from 'services/entitiesService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderSubtitle = ({ tags, ...record }) => {
  const defaultTags =
    tags ||
    record?.entityProfile?.map((item, idx) => {
      const profileColor = entitiesService.getEntityProfileColor(item);
      return {
        key: idx,
        label: translateX(item?.toLowerCase()),
        color: profileColor,
        textColor: profileColor, // Fixed text color (won't change with dark/light mode)
      };
    });

  return <SimpleTag tags={defaultTags?.filter(i => i?.label)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderSubtitle;

// *******************************************************************************
// HELPERS
// *******************************************************************************
